// Presentation-only aliases. Canonical owner IDs continue to drive API and scoring mappings.
const TEAM_NAMES: Record<string, string> = {
  adam: 'Adam Never Learns',
  ads: 'Adam Never Learns',
  melissa: "Melissa's Conquerers",
  sam: "Sam's Big Cats",
  russ: "Russ Wilson's Former",
  russell: "Russ Wilson's Former",
};

export const getFantasyTeamName = (owner?: string): string => {
  if (!owner) return '';
  return TEAM_NAMES[owner.toLowerCase()]
    || owner.charAt(0).toUpperCase() + owner.slice(1);
};
